import { render, staticRenderFns } from "./Tariffs.vue?vue&type=template&id=69c52347&scoped=true&"
import script from "./Tariffs.vue?vue&type=script&lang=js&"
export * from "./Tariffs.vue?vue&type=script&lang=js&"
import style0 from "./Tariffs.vue?vue&type=style&index=0&id=69c52347&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c52347",
  null
  
)

export default component.exports